import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Team-up with Our iOS App Development Firm in Dubai to Digitally
              Transform Your Business
            </h2>
            <p>
              TekRevol, one of the leading iPad and iPhone app development
              company, offers transformative solutions. Our skilled iOS
              developers in Dubai excel at all levels of business. What
              distinguishes us is our untiring commitment to distinction and
              cost-effectiveness, warranting competitive rates without
              compromising quality.
            </p>
            <p>
              Collaborate with the pioneering iOS app development agency in
              Dubai, UAE to digitally transform your business.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <StaticImage
              src="../../images/location_new/fold5/Team-up-ios-dubai.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={866}
              height={1042}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
